import { action } from "satcheljs";
import type { QuickComposeEntrySourceType, FullComposeEntrySourceType, CloseFormReason, } from "owa-calendar-helpers-types/lib/ComposeMetricTypes";
import type { FullComposeFormViewType, QuickComposeViewType, } from "owa-calendar-helpers-types/lib/ComposeTypes";
import type { ClientItemId } from "owa-client-ids";
import type { AttachmentFileList } from "owa-attachment-file-types";
import type { IntervalSelectionProperties } from "owa-calendar-helpers-types/lib/IntervalSelectionProperties";

/*
 * Actions to notify listeners (ex: surface, calendar module) when forms are opening
 * and closing
 */

export interface OnShowFullComposeActionMessage {
    formId: string;
    viewType: FullComposeFormViewType;
    itemId: ClientItemId | undefined;
    entrySource: FullComposeEntrySourceType | undefined;
    attachmentFiles: AttachmentFileList | undefined;
}
export const onShowFullCompose: (formId: string, viewType: FullComposeFormViewType, itemId?: ClientItemId, entrySource?: FullComposeEntrySourceType, attachmentFiles?: AttachmentFileList) => OnShowFullComposeActionMessage = action("onShowFullCompose", (formId: string, viewType: FullComposeFormViewType, itemId?: ClientItemId, entrySource?: FullComposeEntrySourceType, attachmentFiles?: AttachmentFileList): OnShowFullComposeActionMessage => ({
    formId,
    viewType,
    itemId,
    entrySource,
    attachmentFiles,
}));
export interface OnCloseFullComposeActionMessage {
    quickComposeEntrySource: QuickComposeEntrySourceType | null;
    formId: string;
    viewType: FullComposeFormViewType;
    shouldClearPreview: boolean;
    intervalSelectionProps: IntervalSelectionProperties | undefined;
    itemId: ClientItemId | undefined;
    shouldCleanupStoreMutator: boolean | undefined;
}
export const onCloseFullCompose: (quickComposeEntrySource: QuickComposeEntrySourceType | null, formId: string, viewType: FullComposeFormViewType, shouldClearPreview: boolean, intervalSelectionProps?: IntervalSelectionProperties, itemId?: ClientItemId, shouldCleanupStoreMutator?: boolean) => OnCloseFullComposeActionMessage = action("onCloseFullCompose", (quickComposeEntrySource: QuickComposeEntrySourceType | null, formId: string, viewType: FullComposeFormViewType, shouldClearPreview: boolean, intervalSelectionProps?: IntervalSelectionProperties, itemId?: ClientItemId, shouldCleanupStoreMutator?: boolean): OnCloseFullComposeActionMessage => ({
    quickComposeEntrySource,
    formId,
    viewType,
    shouldClearPreview,
    intervalSelectionProps,
    itemId,
    shouldCleanupStoreMutator,
}));

export interface OnShowQuickComposeActionMessage {
    formId: string;
    viewType: QuickComposeViewType;
}
export const onShowQuickCompose: (formId: string, viewType: QuickComposeViewType) => OnShowQuickComposeActionMessage = action("onShowQuickCompose", (formId: string, viewType: QuickComposeViewType): OnShowQuickComposeActionMessage => ({
    formId,
    viewType,
}));
export interface OnCloseQuickComposeActionMessage {
    quickComposeEntrySource: QuickComposeEntrySourceType | null;
    formId: string;
    viewType: QuickComposeViewType;
    shouldClearPreview: boolean;
    intervalSelectionProps: IntervalSelectionProperties | undefined;
    closeFormReason: CloseFormReason | undefined;
    itemId: ClientItemId | undefined;
}
export const onCloseQuickCompose: (quickComposeEntrySource: QuickComposeEntrySourceType | null, formId: string, viewType: QuickComposeViewType, shouldClearPreview: boolean, intervalSelectionProps?: IntervalSelectionProperties, closeFormReason?: CloseFormReason, itemId?: ClientItemId) => OnCloseQuickComposeActionMessage = action("onCloseQuickCompose", (quickComposeEntrySource: QuickComposeEntrySourceType | null, formId: string, viewType: QuickComposeViewType, shouldClearPreview: boolean, intervalSelectionProps?: IntervalSelectionProperties, closeFormReason?: CloseFormReason, itemId?: ClientItemId): OnCloseQuickComposeActionMessage => ({
    quickComposeEntrySource,
    formId,
    viewType,
    shouldClearPreview,
    intervalSelectionProps,
    closeFormReason,
    itemId,
}));
